import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
    customerId: string;
    type: string;
    selected: boolean;
}

export const useSetSelectedPaymentOption = ({ customerId, type, selected }: IProps) => useMutation(
  'setSelectedPaymentOption',
  async () => {
    const { data } = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/paymentOptions/${type}`, { selected });
    return data;
  },
  {
    retry: 1,
  },
);
